import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';


import { FuseSharedModule } from '@fuse/shared.module';


const routes = [
    {
        path        : 'dashboard',
        loadChildren: './dashboards/dashboard.module#DashboardModule'
    },
    {
        path        : 'user-role-master',
        loadChildren: './user-role-master/user-role-master.module#UserRoleMasterModule'
    },
    {
        path        : 'user-role-permission',
        loadChildren: './user-role-permission/user-role-permission.module#UserRolePermissionModule'
    },
    {
        path: 'charts',
        loadChildren: () => import('app/main/apps/chartexpandview/chartexpandview.module').then(m => m.ChartexpandviewModule)
    },
    {
        path: 'autorepaycharts',
        loadChildren: () => import('app/main/apps/autorepaychartexpandview/autorepaychartexpandview.module').then(m => m.AutorepaychartexpandviewModule)
    },
    {
        path        : 'company-bases',
        loadChildren: './company-bases/companybases.module#companybaseModule'
    },
    {
        path        : 'IndividualBase',
        loadChildren: './IndividualBase/Individualbase.module#IndividualbaseModule'
    },
    {
        path        : 'TransferDetails',
        loadChildren: './TransferDetails/TransferDetails.module#TransferDetailsModule'
    },
    {
        path        : 'block-transfer',
        loadChildren: './block-transfer/block-transfer.module#BlockTransferModule'
    },
    {
        path        : 'report',
        loadChildren: './report/report.module#ReportModule'
    },
    {
        path        : 'login',
        loadChildren: './login/login.module#LoginModule'
    },

    /*{
        path        : 'UserRolesList',
        loadChildren: './user-role-permission/user-role-permission.module#UserRolePermissionModule'
    },*/

    // Auto Repayment Route
    {
        path        : 'autopay-company-bases',
        loadChildren: './auto-repayment/autopay-company-bases/autopay-company-bases.module#AutopayCompanyBasesModule'
    },

    {
        path        : 'autopay-individual-bases',
        loadChildren: './auto-repayment/autopay-individual-bases/autopay-individual-bases.module#AutopayIndividualBasesModule'
    },

    {
        path        : 'autopay-transfer-detail',
        loadChildren: './auto-repayment/autopay-transfer-detail/autopay-transfer-detail.module#AutopayTransferDetailModule'
    },
   
    {
        path        : 'block-transfers',
        loadChildren: './autorepaymentblock/block-ar.module#BlockArModule'
    },
    {
        path        : 'AutopayReport',
        loadChildren: './auto-repayment/autopay-report/autopay-report.module#AutopayReportModule'
    },
    {
        path        : 'changepassword',
        loadChildren: './changepassword/changepassword.module#ChangepasswordModule'
    },
    {
        path        : 'forgotpassword',
        loadChildren: './forgotpassword/forgotpassword.module#ForgotPasswordModule'
    },
    {
        path        : 'newpassword',
        loadChildren: './newpassword/newpassword.module#NewpasswordModule'
    },
    {
        path        : 'logout',
        loadChildren: './logout/logout.module#LogoutModule'
    },
    {
        path        : 'user-profile',
        loadChildren: './user-profile/user-profile.module#UserProfileModule'
    },
];

@NgModule({
    imports     : [
        RouterModule.forChild(routes),
        FuseSharedModule,

    ],
    declarations: []
})
export class AppsModule
{
}
